class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // theme: open submenus on hover for mouse/fine-pointer desktop users.
    // Gated on a hover+fine-pointer media query so touch and keyboard keep
    // the native click/Enter toggle (accessibility + no touch interference).
    this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    // Grace period so the cursor can cross the gap between the trigger and the
    // absolutely-positioned panel without the menu closing under it. Re-entering
    // the element (mouseenter, incl. onto the panel) cancels the pending close.
    this.closeDelay = 220;
    this.closeTimer = null;
    this.addEventListener('mouseenter', this.onHoverIn.bind(this));
    this.addEventListener('mouseleave', this.onHoverOut.bind(this));
  }

  onHoverIn() {
    if (!this.hoverMedia.matches) return;
    clearTimeout(this.closeTimer);
    if (this.mainDetailsToggle.open) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onHoverOut() {
    if (!this.hoverMedia.matches || !this.mainDetailsToggle.open) return;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      // Only close if the pointer is genuinely no longer over the trigger or panel.
      if (!this.matches(':hover')) this.close();
    }, this.closeDelay);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
